export enum ViewModes {
    cards = "cards",
    map = "map",
}

export enum ViewModeKeys {
    showCardDetails = "showCardDetails",
    showFilterDetails = "showFilterDetails",
    showListView = "showListView",
    viewMode = "portfolioViewMode",
}
